import templateUrl from "emun.blog/blog-prompt.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import form from "emun.blog/blog.formio";
import formioController from "webforms/formio/formio.controller";
import AutoQuery from "servicestack/auto-query/auto-query";

class controller {
  constructor($scope, options) {
    const $ctrl = this;
    formioController($ctrl, $scope);
    $ctrl.bus = new ServiceBus();
    $ctrl.form = form;
    $ctrl.title = options.title || " Corporate Message...";
	$ctrl.blog = options.blog || {};
	$ctrl.submissionId = $ctrl.blog.id;
	$ctrl.submission = {
		label: "blog",
		data: {},
    tags: {}
	};
    if ($ctrl.submissionId) {
      $ctrl.bus
        .send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
        .then(({ data }) => {
          if (data.results.length) {
            $ctrl.submission = data.results[0];
          }
        });
    }
  }

  formSubmission(e, submission) {
    const $ctrl = this;
	console.debug("formSubmission", { $ctrl, e, submission });
	$ctrl.submission = submission;
	$ctrl.$broadcast("$blogSubmitted");
	$ctrl.$dismiss();
  }
}

export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
		  controllerAs: "$ctrl",
		  size: 'lg'
        },
        (options || {}).modal
      )
    ).result;
  }
};
